import { getStatePure } from '~src/state';
import $ from 'jquery';

export const getSelectedPagesByUser = () => {
  const pages = getStatePure('pages');

  if (pages.length === 1) {
    return pages;
  }
  var selectedPages;
  let selectPages = $('#navbar-submenu-export-select-pages').select2('data');

  if (selectPages.length === 0) {
    selectedPages = pages;
  } else {
    selectedPages = selectPages;
  }

  const selectedPagesIds = [];
  for (let selectedPage of selectedPages) {
    if (selectedPage.id) {
      // uso id delle pagine selezionate tramite select2
      selectedPagesIds.push({ id: selectedPage.id });
    }
    if (selectedPage.temporaryId) {
      // uso temporaryId per le pagine non salvate
      selectedPagesIds.push({ id: selectedPage.temporaryId });
    }
    if (selectedPage.objectId) {
      // uso objectId per le pagine che vengono prelevate direttamente da pages (salvate)
      selectedPagesIds.push({ id: selectedPage.objectId });
    }
  }
  const pagesSelectedByUser = pages.filter((page) => {
    return selectedPagesIds.some((selected) => {
      let id;
      if (page.objectId) {
        id = page.objectId;
      } else {
        id = page.temporaryId;
      }
      return selected.id === id;
    });
  });

  return pagesSelectedByUser;
};
